/** Anything focus can be moved to: an element, or MUI Select's imperative `inputRef` handle. */
export interface FocusTarget {
  focus: () => void;
  /** MUI Select's handle: the hidden native input, just after the visible control. */
  node?: HTMLElement;
}

const isElement = (value: unknown): value is HTMLElement =>
  typeof HTMLElement !== 'undefined' && value instanceof HTMLElement;

/**
 * Take a person to a field after a refused submit: scroll it to the middle of
 * the view (clear of a sticky send bar on a phone), then focus it without a
 * second jump, so its error is what a screen reader reads next.
 *
 * Shared by every form's submit validation. A refused submit that only paints
 * an error on a field above the fold looks, to the person pressing the
 * button, like nothing happened at all.
 */
export function focusField(target: FocusTarget | HTMLElement | null | undefined): void {
  if (!target) return;
  if (isElement(target)) {
    target.scrollIntoView?.({ block: 'center' });
    target.focus({ preventScroll: true });
    return;
  }
  const visible = (target.node?.previousElementSibling as HTMLElement | null) ?? target.node;
  visible?.scrollIntoView?.({ block: 'center' });
  target.focus();
}
